import {
    Message
} from 'element-ui';

let mixin = {
    methods: {
        dateFormatter(date, fmt) {
            let o = {
                "M+": date.getMonth() + 1, //月份
                "d+": date.getDate(), //日
                "h+": date.getHours(), //小时
                "m+": date.getMinutes(), //分
                "s+": date.getSeconds(), //秒
                "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                "S": date.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        },
        //深拷贝
        deepCopy(arr) {
            if (arr instanceof Array) {
                let n = [];
                for (let i = 0; i < arr.length; ++i) {
                    n[i] = this.deepCopy(arr[i]);
                }
                return n;

            } else if (arr instanceof Object) {
                let n = {};
                for (let i in arr) {
                    n[i] = this.deepCopy(arr[i]);
                }
                return n;
            } else {
                return arr;
            }
        },
        /**
         * 向下取整计算精度
         * @param value
         * @param precision
         * @returns {number}
         */
        getFloorNum(value, precision) {
            if (String(value).indexOf('.') > 0 && String(value).split('.')[1].length > precision) {
                value = Math.floor(value * Math.pow(10, precision)) / Math.pow(10, precision);
            }
            return Number(value);
        },

        getFloorNum1(value, precision) {
            if (String(value).indexOf('.') > 0 && String(value).split('.')[1].length > precision) {
                value = Math.floor(value * Math.pow(10, precision)) / Math.pow(10, precision);
            }
            return value;
        },

        /**
         * 向下取整，并且补全位数
         * @param value
         * @param precision
         * @returns {number}
         */
        getFloorNumAndComplemented(value, precision) {
            if (String(value).indexOf('.') > 0 && String(value).split('.')[1].length > precision) {
                value = Math.floor(value * Math.pow(10, precision)) / Math.pow(10, precision);
            } else if (String(value).indexOf('.') > 0 && String(value).split('.')[1].length < precision) {
                let z_amount = precision - String(value).split('.')[1].length;
                let z_str = "";
                while (z_amount > 0) {
                    z_str = z_str + "0";
                    z_amount--;
                }
                value = value + z_str;
            } else if (String(value).indexOf('.') <= 0) {
                let z_amount = precision;
                let z_str = ".";
                while (z_amount > 0) {
                    z_str = z_str + "0";
                    z_amount--;
                }
                value = value + z_str;
            }
            return value;
        },
        /**
         * 向下取整计算精度(位数小于precision不做处理，大于precision向下取整保留precision位，precision=2时除外)
         * @param value
         * @param precision
         * @returns {number}
         */
        getFloatNum(value, precision) {
            if (value !== '' && value !== undefined) {
                if (String(value).indexOf('.') > 0 && String(value).split('.')[1].length > precision) {
                    value = Math.floor(value * Math.pow(10, precision)) / Math.pow(10, precision);
                }
                if (precision === 2) {
                    value = Math.floor(value * Math.pow(10, precision)) / Math.pow(10, precision);
                    value = Number(value).toFixed(precision);
                }
                return value;
            }
        },

        /**
         * 手机号码隐藏中间四位
         * @param number
         * @returns {string}
         */
        hidePhoneNumber(number) {
            let str = number.toString();
            return str.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
        },

        /**
         * 获取剩余时间（时:分:秒）
         * @param leftTime 毫秒数
         */
        getTimeRemaining(leftTime) {
            let dValue = leftTime / 1000;
            let str = "";
            if (dValue / 3600 >= 1) {
                let tempStr = "";
                if (dValue < 10) {
                    tempStr = "0"
                }
                str += tempStr + parseInt((dValue / 3600).toString());
                dValue = dValue % 3600;
            } else {
                str += '00'
            }
            if (dValue / 60 >= 1) {
                let tempStr = ":";
                if (dValue < 10) {
                    tempStr = ":0"
                }
                str += tempStr + parseInt((dValue / 60).toString());
                dValue = dValue % 60;
            } else {
                str += ':00'
            }
            let tempStr = ":";
            if (dValue < 10) {
                tempStr = ":0"
            }
            str += tempStr + parseInt(dValue.toString());
            return str;
        },

        /**
         * 获取剩余时间（**天**时**分**秒）
         * @param time
         */
        getTimeRemaining_days(nowTime, startTime) {
            let dValue = (startTime - nowTime) / 1000;
            let str = "";

            if (dValue / (3600 * 24) >= 1) {
                str += parseInt((dValue / (3600 * 24)).toString()) + '天';
                dValue = dValue % (3600 * 24);
            } else {
                str += '0天'
            }
            if (dValue / 3600 >= 1) {
                str += parseInt((dValue / 3600).toString()) + '时';
                dValue = dValue % 3600;
            } else {
                str += '0时'
            }
            if (dValue / 60 >= 1) {
                str += parseInt((dValue / 60).toString()) + '分';
                dValue = dValue % 60;
            } else {
                str += '0分'
            }
            str += parseInt(dValue.toString()) + '秒';
            return str;
        },

        /**
         *
         * @param str
         */
        getVipLelStr(str) {
            return this.$t('vip')[str];
        },
        /**
         * volume排序
         * @param a
         * @param b
         * @returns {number}
         */
        getSort_v(a, b) {
            return parseFloat(a.v) - parseFloat(b.v);
        },
        /**
         * p 排序
         * @param a
         * @param b
         */
        getSort_p(a, b) {
            return parseFloat(a.p) - parseFloat(b.p);
        },
        /**
         * c 排序
         * @param a
         * @param b
         */
        getSort_c(a, b) {
            return parseFloat(a.c) - parseFloat(b.c);
        },
        /**
         * to 排序
         * @param a
         * @param b
         */
        getSort_to(a, b) {
            return parseFloat(a.to) - parseFloat(b.to);
        },
        elMessage(type, msg) {
            Message({
                type: type,
                message: msg
            })
        }

    }
}
export default mixin